import * as React from 'react';
import { useViewport } from '../viewport-provider';
export var MaxViewportContext = React.createContext(undefined);
/**
 * Used to limit the maximum view size for child components.
 */
export var MaxViewport = function (props) {
    var maxSize = props.maxSize;
    var viewSizes = useViewport().viewSizes;
    // check to see if the maxSize was set higher up in the tree
    var parentMaxSize = useMaxViewport();
    var appliedMaxSize = parentMaxSize && viewSizes[parentMaxSize] < viewSizes[maxSize] ? parentMaxSize : maxSize;
    return React.createElement(MaxViewportContext.Provider, { value: appliedMaxSize }, props.children);
};
MaxViewport.displayName = 'MaxViewport';
export var useMaxViewport = function () { return React.useContext(MaxViewportContext); };
//# sourceMappingURL=max-viewport.js.map